import React, { useState } from "react";
import "./Projects.css";

// Import Images
import spotify from "./assets/spotify.png";
import trading from "./assets/trading.png";
import stockPrediction from "./assets/stock_price.png";
import horrorAnalysis from "./assets/horror.png";
import DNAC from "./assets/DNAC.png";
import crash from "./assets/crash.png"
import vr from "./assets/vr.png";
const personalProjects = [
  {
    "title": "Low Latency Trading System",
    "description": "A high-performance trading engine designed for ultra-fast order execution with sub-millisecond latency. Implements Smart Order Routing (SOR), real-time market data processing, and efficient trade execution using UDP and WebSockets. Optimized for scalability and fault tolerance, ensuring seamless order flow across multiple exchanges.",
    "techStack": ["C++", "Docker", "Python", "React", "UDP", "WebSockets", "Railway"],
    "github": "https://github.com/ABBU2712/Low-Latecy-Trading-System",
    "demo": "",
    "image": trading
}
,
  {
    title: "Spotify Multiclass Genre Classification",
    description: "A music genre classifier using KNN and Random Forest, boosting accuracy by 17%.",
    techStack: ["Python", "Machine Learning", "Streamlit"],
    github: "https://github.com/ABBU2712/WINTER-PROJECT",
    demo: "",
    image: spotify,  // ✅ Fixing the image import
  },
   { title: "Distributed Stock Price Prediction",
    description: "Real-time stock price prediction using ARIMA and LSTM models with AWS.",
    techStack: ["Python", "TensorFlow", "AWS"],
    github: "https://github.com/ABBU2712/STOCK-PRICE-PREDICTION",
    demo: "",
    image: stockPrediction,  // ✅ Fixing the image import
  },
  {
    title: "Horror Movie Rating Analysis",
    description: "Identified key factors for low ratings using RoBERTa and LDA.",
    techStack: ["Python", "NLP", "LDA", "RoBERTa"],
    github: "https://github.com/PranavDherange/text-summariser",
    demo: "",
    image: horrorAnalysis,  // ✅ Fixing the image import
  },

];

const professionalProjects = [{ title: "DNACenter Ansible",
  description: "Infrastructure as code development for Cisco's DNA Center (currently known as Catalyst Center) deployments on WLC controllers, switches and routers",
  techStack: ["Python", "Ansible", "Terraform", "Splunk", "CircleCI"],
  github: "https://github.com/cisco-en-programmability/dnacenter-ansible",
  demo: "",
  image: DNAC,  // ✅ Fixing the image import
},
{ title: "House Party VR",
  description: "A virtual reality application for hosting house parties, allowing users to interact in a virtual environment with friends and family. Developed using Unity and C#.",
  techStack: ["Unity", "C#", "ConVAI", "GPT-3"],
  github: "https://github.com/ABBU2712/House-Parrty/tree/main",
  demo: "https://www.youtube.com/watch?v=EOPxpAMV_fE",
  image: vr,  // ✅ Fixing the image import
}];
  

const voluntaryProjects = [{ title: "Explorer Transportation Data Science Project",
  description: "Data Science project on traffic data analysis, road safety insights, machine learning models for predictive analysis, under the guidance of Northeast Big Data Innovation Hub",
  techStack: ["Python", "Random Forest", "Pandas", "Matplotlib", "Folium"],
  github: "https://github.com/ABBU2712/Explorer-TDSP",
  demo: "",
  image: crash,  // ✅ Fixing the image import
}];

function Projects() {
  const [selectedCategory, setSelectedCategory] = useState("Personal");
  const [selectedProject, setSelectedProject] = useState(null);
  const [xp, setXp] = useState(0); // XP System for viewing projects

  // Function to select category
  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };

  // Function to open project details and add XP
  const openModal = (project) => {
    setSelectedProject(project);
    setXp(xp + 100); // Gain XP for exploring projects
  };

  // Close project details
  const closeModal = () => {
    setSelectedProject(null);
  };

  // Function to get projects based on category
  const getProjects = () => {
    if (selectedCategory === "Personal") return personalProjects;
    if (selectedCategory === "Professional") return professionalProjects;
    if (selectedCategory === "Voluntary") return voluntaryProjects;
  };

  return (
    <div className="projects-container">
      <h1>🚀 Projects</h1>

      {/* Category Selector */}
      <div className="category-buttons">
        {["Personal", "Professional", "Voluntary"].map((category) => (
          <button
            key={category}
            className={`category-btn ${selectedCategory === category ? "active" : ""}`}
            onClick={() => handleCategoryChange(category)}
          >
            {category}
          </button>
        ))}
      </div>

      {/* XP Bar */}
      <div className="xp-bar-container">
        <p>🎮 XP Gained: {xp}</p>
        <div className="xp-bar">
          <div className="xp-fill" style={{ width: `${(xp / 500) * 100}%` }}></div>
        </div>
      </div>

      {/* Projects Grid */}
      <div className="project-grid" style={{ gridTemplateColumns: `repeat(${Math.max(getProjects().length, 4)}, 1fr)` }}>
        {getProjects().map((project, index) => (
          <div key={index} className="project-card" onClick={() => openModal(project)}>
            <img src={project.image} alt={project.title} className="project-image" />
            <h2>{project.title}</h2>
            <p>{project.description}</p>
          </div>
        ))}
      </div>

      {/* Project Modal */}
      {selectedProject && (
        <div className="modal">
          <div className="modal-content">
            <h2>{selectedProject.title}</h2>
            <p>{selectedProject.description}</p>
            <p>
              <strong>Tech Stack:</strong> {selectedProject.techStack.join(", ")}
            </p>
            {selectedProject.github && (
              <a href={selectedProject.github} target="_blank" rel="noopener noreferrer">
                GitHub
              </a>
            )}
            {selectedProject.demo && (
              <a href={selectedProject.demo} target="_blank" rel="noopener noreferrer">
                Live Demo
              </a>
            )}
            <button onClick={closeModal}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Projects;
